import React, { useEffect } from 'react';
import { Landing } from './pages/Landing';
import { initMetaPixel } from './utils/metaPixel';
const INTERACTION_EVENTS = ['pointerdown', 'keydown', 'scroll', 'touchstart'] as const;
export function App() {
  useEffect(() => {
    // Analytics is deferred until the visitor interacts (or shortly after load),
    // so its ~220 KB never competes with the hero image for bandwidth.
    let started = false;
    const start = () => {
      if (started) return;
      started = true;
      INTERACTION_EVENTS.forEach(event => window.removeEventListener(event, start));
      window.clearTimeout(timer);
      initMetaPixel();
    };
    const timer = window.setTimeout(start, 4000);
    INTERACTION_EVENTS.forEach(event => window.addEventListener(event, start, {
      once: true,
      passive: true
    }));
    return () => {
      window.clearTimeout(timer);
      INTERACTION_EVENTS.forEach(event => window.removeEventListener(event, start));
    };
  }, []);
  return <Landing data-id="element-0" data-mp="3ijxqiu0iq6lh" />;
}